import { type ISpeakerVM, speakerVMFromName } from "../../lib/speaker-vm"

export const BOILERPLATE_LEAD =
  /^(discussion of|discussion about|conversation about|talking about|talk about|review of)\s+/i

/** Strip "Discussion about / Conversation regarding" lead-ins so the chip
 * shows the actual subject, not the verb. */
export function stripBoilerplate(s: string): string {
  return s.replace(BOILERPLATE_LEAD, "").trim()
}

/**
 * Build a legend view-model for an internally-derived speaker (no unified
 * `speakers` prop). `label` is pinned to the resolved owner name — not left null
 * as `speakerVMFromName` does — so the chip's edit key, its `onSpeakerClick`
 * payload, and its `data-testid` stay byte-identical to what the pre-chip legend
 * passed (MeetingSummaryView keys its rename modal on exactly this value, and a
 * far-end `Remote::Bob` must click through as `Remote::Bob`, not the stripped
 * display name). The legend chip only reads `label` for that key, so overriding
 * it changes nothing else.
 */
export function legendSpeakerVM(name: string, colorMap: Map<string, string> | undefined): ISpeakerVM {
  return { ...speakerVMFromName(name, colorMap), label: name }
}
